export const REQUIRED_DOCS: any[] = [
  {
    name: 'Customer Instruction',
    description: 'Customer Instruction',
    required: true,
  },
];

export const COUNTRY_CODES: any[] = [
  { bankId: '11', countryCode: 'SS' },
  { bankId: '43', countryCode: 'CD' },
  { bankId: '50', countryCode: 'RW' },
  { bankId: '54', countryCode: 'KE' },
  { bankId: '55', countryCode: 'TZ' },
  { bankId: '56', countryCode: 'UG' },
];

export const BICs = [
  {
    code: 'ABCLKENAXXX',
    bankName: 'AFRICAN BANKING CORPORATION LTD    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'ABNGKENAXXX',
    bankName: 'ACCESS BANK (KENYA) LIMITED    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'AFDBKEN1XXX',
    bankName: 'AFRICAN DEVELOPMENT BANK    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'AFRIKENXXXX',
    bankName: 'BANK OF AFRICA KENYA LTD    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'ASHSKEN1XXX',
    bankName: 'AFRIKA INVESTMENT BANK LTD    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'BARBKENAXXX',
    bankName: 'BANK OF BARODA (KENYA) LTD    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'BARCKENXXXX',
    bankName: 'ABSA BANK KENYA, LTD.    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'BIBKKEN1XXX',
    bankName: 'BIASHARA BANK OF KENYA LTD.    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'BKIDKEM1XXX',
    bankName: 'BANK OF INDIA    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'BKIDKENAXXX',
    bankName: 'BANK OF INDIA    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'CBAFKENXXXX',
    bankName: 'COMMERCIAL BANK OF AFRICA LTD.    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'CBKEKENXXXX',
    bankName: 'CENTRAL BANK OF KENYA    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'CHBLKENXXXX',
    bankName: 'CHARTERHOUSE BANK LIMITED    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'CIFIKENAXXX',
    bankName: 'KINGDOM BANK LTD    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'CITIKENAXXX',
    bankName: 'CITIBANK N.A. NAIROBI    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'CKENKENAXXX',
    bankName: 'CHASE BANK (KENYA) LIMITED    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'CONKKENAXXX',
    bankName: 'CONSOLIDATED BANK OF KENYA LTD    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'CRBTKENAXXX',
    bankName: 'CREDIT BANK LIMITED    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'CRMFKENAXXX',
    bankName: 'CARITAS MICROFINANCE BANK LIMITED    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'DELFKENAXXX',
    bankName: 'ORIENTAL COMMERCIAL BANK LTD    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'DEVKKENAXXX',
    bankName: 'DEVELOPMENT BANK OF KENYA LIMITED    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'DTKEKENAXXX',
    bankName: 'DIAMOND TRUST BANK KENYA LIMITED    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'DUIBKENAXXX',
    bankName: 'DIB BANK LTD    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'DUKNKENAXXX',
    bankName: 'DUBAI BANK KENYA LTD    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'EADBKEN1XXX',
    bankName: 'EAST AFRICAN DEVELOPMENT BANK    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'ECOCKENAXXX',
    bankName: 'ECOBANK KENYA LTD    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'EQBLKENAXXX',
    bankName: 'EQUITY BANK LIMITED    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'EQUAKENAXXX',
    bankName: 'EQUATORIAL COMM.BANK LTD.     ',
    bankCountryCode: 'KE',
  },
  {
    code: 'ESATKENAXXX',
    bankName: 'EASTERN AND SOUTHERN AFRICAN TRADE     AND DEVELOPMENTBANK',
    bankCountryCode: 'KE',
  },
  {
    code: 'EUOOKEN1XXX',
    bankName: 'EURO BANK    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'FABLKENAXXX',
    bankName: 'FAMILY BANK LIMITED    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'FASRKEN1XXX',
    bankName: 'FAIDA INVESTMENT BANK LTD    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'FAUMKENAXXX',
    bankName: 'FAULU MICROFINANCE BANK    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'FBAKKENAXXX',
    bankName: 'FINA BANK LIMITED             ',
    bankCountryCode: 'KE',
  },
  {
    code: 'FCBLKENAXXX',
    bankName: 'FIDELITY COMMERCIAL BANK LTD  ',
    bankCountryCode: 'KE',
  },
  {
    code: 'FRDRKEN1XXX',
    bankName: 'DRUMMOND INVESTMENT BANK LIMITED    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'GAFRKENAXXX',
    bankName: 'GULF AFRICAN BANK LTD    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'GIROKENXXXX',
    bankName: 'GIRO COMMERCIAL BANK LTD    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'GTBIKENAXXX',
    bankName: 'GUARANTY TRUST BANK (K) LTD    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'GUARKENAXXX',
    bankName: 'GUARDIAN BANK LIMITED    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'HABBKENXXXX',
    bankName: 'HABIB BANK LIMITED    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'HBZUKENAXXX',
    bankName: 'HABIB BANK AG ZURICH    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'IFCBKENAXXX',
    bankName: 'FIRST COMMUNITY BANK LIMITED    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'IMBLKENAXXX',
    bankName: 'I AND M BANK LTD    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'IMPLKENAXXX',
    bankName: 'IMPERIAL BANK LIMITED    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'KCBLKENXXXX',
    bankName: 'KENYA COMMERCIAL BANK LIMITED    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'KCOOKENAXXX',
    bankName: 'COOPERATIVE BANK OF KENYA LTD    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'KPOBKEN1XXX',
    bankName: 'KENYA POST OFFICE SAVINGS BANK    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'KREPKENAXXX',
    bankName: 'K-REP BANK LIMITED    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'KWMIKENXXXX',
    bankName: 'KENYA WOMEN MICROFINANCE BANK    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'MIEKKENAXXX',
    bankName: 'MIDDLE EAST BANK KENYA LTD    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'MORBKENAXXX',
    bankName: 'M-ORIENTAL BANK    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'MYBKKENAXXX',
    bankName: 'MAYFAIR BANK    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'NBKEKENXXXX',
    bankName: 'NATIONAL BANK OF KENYA LTD.    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'NINCKENAXXX',
    bankName: 'NATIONAL IND.CREDIT BANK LTD  ',
    bankCountryCode: 'KE',
  },
  {
    code: 'PABLKEN1XXX',
    bankName: 'PANAFRICAN BANK LIMITED    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'PAUTKENAXXX',
    bankName: 'PARAMOUNT UNIVERSAL BANK LIMITED    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'PRIEKENXXXX',
    bankName: 'PRIME BANK LTD.    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'SBICKENXXXX',
    bankName: 'CFC STANBIC BANK LIMITED    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'SBMKKENAXXX',
    bankName: 'SBM BANK LTD    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'SCBLKENXXXX',
    bankName: 'STANDARD CHARTERED BANK KENYA LIMIT    ED',
    bankCountryCode: 'KE',
  },
  {
    code: 'SIDNKENAXXX',
    bankName: 'SYDIAN BANK LIMITED    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'SOCRKENAXXX',
    bankName: 'SOUTHERN CREDIT BANKING CORPORATION     LTD',
    bankCountryCode: 'KE',
  },
  {
    code: 'SPBLKENAXXX',
    bankName: 'SPIRE BANK LTD    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'STSKKEN1XXX',
    bankName: 'STANDARD INVESTMENT BANK LTD    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'SUSTKEN1XXX',
    bankName: 'SUNTRA INVESTMENT BANK LTD    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'TNBLKENAXXX',
    bankName: 'TRANS-NATIONAL BANK LIMITED    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'UNAFKENAXXX',
    bankName: 'UBA KENYA BANK LIMITED    ',
    bankCountryCode: 'KE',
  },
  {
    code: 'VICMKENAXXX',
    bankName: 'VICTORIA COMMERCIAL BANK LIMITED    ',
    bankCountryCode: 'KE',
  },
];
